<template>
<div class="champion-wrap">
    <h2 class="champion-label">スーパークロス全日本チャンピオン</h2>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('90')"><span class="history__head--circle">1994-1997</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">1994年<span class="year-title__sub">平成6年</span></h2>
                <ul>
                    <li>高見俊次／国際A級125cc</li>
                    <li>榎本正則／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1995年<span class="year-title__sub">平成7年</span></h2>
                <ul>
                    <li>辻本幸二／国際A級125cc</li>
                    <li>小橋雅也／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1996年<span class="year-title__sub">平成8年</span></h2>
                <ul>
                    <li>溝口哲也／国際A級125cc</li>
                    <li>熱田高輝／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1997年<span class="year-title__sub">平成9年</span></h2>
                <ul>
                    <li>加賀真一／国際A級125cc</li>
                    <li>熱田高輝／国際A級250cc</li>
                </ul>
            </section>
        </div>
    </div>
</div>
</template>

<script>
    import Mixin from '@/mixins/mixin.js'
    export default {
        data: function() {
            return {
                show_contents: ['90']
            }
        },
        mixins: [Mixin],
    }
</script>

<style lang="scss">

</style>